module.exports = __webpack_public_path__ + "static/19-Y2K-december1999-option2-a187d9af26917a2a82b8b3284462af78.jpg";